import { useMutation } from "@apollo/client";
import React, { useState } from "react";
import { UPDATE_USER_PASSWORD_MUTATION } from "../GraphQl/Mutations";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { FaSpinner } from "react-icons/fa";
import Loader from "../components/Loader";
import { message } from "antd";

const ForgotPassword = () => {
  const [tempPassword, setTempPassword] = useState(null);
  const [msg, setMessage] = useState("");
  const params = useParams();
  const navigate = useNavigate();
  const [resetPassword, { loading }] = useMutation(
    UPDATE_USER_PASSWORD_MUTATION,
    {
      variables: {
        resetToken: params?.id,
        newPassword: tempPassword,
      },
      onCompleted: (data) => {
        success("Reset link sent to email");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      },
      onError: (e) => {
        err("This Link is invalid!");
      },
    }
  );
  const [messageApi, contextHolder] = message.useMessage();
  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };

  const err = (message) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };

  return (
    <section className='resetPasswordWrapper'>
      {contextHolder}
      <div
        className='d-flex align-items-center justify-content-start '
        style={{ paddingTop: "2%", gap: "0 10px", marginBottom: "30px" }}
      >
        <img
          src={process.env.PUBLIC_URL + "/logo.png"}
          style={{ width: "auto", height: "40px" }}
          alt='survey logo'
        />
        <span className='authWrapperTitle'>SurveyHub</span>
      </div>

      <div className='sectionHeaderWrapper flex items-center content-between'>
        <div className='sectionHeaderTitle'> Enter New Password </div>
      </div>
      <div className='sectionContentWrapper'>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setMessage(null);
            resetPassword();
          }}
          className='resetPasswordForm'
        >
          <input
            type='text'
            className='form-control'
            placeholder='Enter new Password'
            required
            onChange={(e) => setTempPassword(e.target.value)}
          />
          <button className='btn btn-primary'>
            {loading && <Loader color='#fff' />} &nbsp; Reset Password
          </button>
        </form>
      </div>
    </section>
  );
};

export default ForgotPassword;
